import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RuleService {

  private http = inject(HttpClient);

  constructor() { }


  get(): Observable<any> {
    return this.http.get(Global.url + 'V1/rule');
  }

  create(data: any): Observable<any> {
    return this.http.post(Global.url + 'V1/rule', data);
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put(Global.url + 'V1/rule/' + id, data);
  }

  delete(id: any): Observable<any> {
    return this.http.delete(Global.url + 'V1/rule/' + id);
  }
}
